import { Document, Page } from "react-pdf";
import React, { useEffect, useState } from "react";
import {
  IconButton,
  FormLabel,
  Popover,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Box,
} from "@mui/material";
import DatePicker from "react-datepicker";
import SignerIcon from "../Icons/SignerIcon";
import PreviewOnlySign from "../PreviewOnlySign";
import CustomTextField from "../Common/CustomTextField";

const Placeholders = ({
  placeholders,
  pageNumber,
  onlyPreviewDocument,
  otherSignerEmail,
  handlePopoverClick,
  onChangeDatePickerHandler,
  onChangeCheckBoxHandler,
  onChangeTextHandler,
  drag,
  onBTNclick,
  emptyFunction,
  pdfFile,
  onPageLoadSuccess,
  handleOnLoadSuccess,
  numPages,
  drop,
  handlePopoverClose,
  onChangeSignerHandler,
  inputFields,
  selectedAction,
  classes,
  anchorEl,
}) => {
  const [pageSize, setPageSize] = useState({ width: 0, height: 0 });
  const [pageOffset, setPageOffset] = useState({ left: 0, top: 0 });

  useEffect(() => {
    const updateSize = () => {
      const canvas = document.querySelector(
        "#divd1 canvas.react-pdf__Page__canvas"
      );
      const container = document.getElementById("overlay-container");
      if (canvas) {
        const rect = canvas.getBoundingClientRect();
        setPageSize({ width: rect.width, height: rect.height });
        if (container) {
          const cRect = container.getBoundingClientRect();
          setPageOffset({ left: rect.left - cRect.left, top: rect.top - cRect.top });
        }
      }
    };
    updateSize();
    window.addEventListener("resize", updateSize);
    const interval = setInterval(updateSize, 300);
    return () => {
      window.removeEventListener("resize", updateSize);
      clearInterval(interval);
    };
  }, [pageNumber]); 

  return (
    <div
      id="divd2"
      style={{
        "min-width": "auto",
        "width": "632px",
        "margin-right": "0px",
        position: "relative",
        overflow: "auto",
      }}
    >
      <div
        id="divd1"
        onDrop={drop}
        onDragOver={(ev) => ev.preventDefault()}
        style={{
          "transform-origin": "left top",
          margin: "0px",
          padding: "0",
        }}
      >
        <Box elevation={10} className={classes.customPaper} style={{ position: "relative", display: "inline-block" }} id="overlay-container">
          {pdfFile && (
            <>
            <Document file={pdfFile} onLoadSuccess={handleOnLoadSuccess}>
              <Page
                style={classes.page}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                customTextRenderer={false}
                pageNumber={pageNumber}
                onLoadSuccess={onPageLoadSuccess}
                width={632.27}
                />
            </Document>
              {numPages && (
                <p style={{ margin: "10px", padding: "10px" }}>
                  Page {pageNumber} of {numPages}
                </p>
              )}
              </>
          )}
          <div style={{ position: "absolute", left: `${pageOffset.left}px`, top: `${pageOffset.top}px`, width: `${pageSize.width}px`, height: `${pageSize.height}px`, pointerEvents: "none" }}>
          {placeholders?.map((item, index) => {
            if (item.pageNumber === pageNumber) {
              const hasPct = typeof item.xPct === "number" && typeof item.yPct === "number";
              const leftPx = hasPct && pageSize.width ? item.xPct * pageSize.width : item.left || 0;
              const topPx = hasPct && pageSize.height ? item.yPct * pageSize.height : item.top || 0;
              return (
                <div
                  key={index}
                  style={{
                    position: "absolute",
                    left: `${leftPx}px`,
                    top: `${topPx}px`,
                    width: "auto",
                    pointerEvents: "auto",
                  }}
                >
                  {onlyPreviewDocument ? (
                    <>
                      <PreviewOnlySign item={item} />
                    </>
                  ) : otherSignerEmail ? (
                    <>
                      <SignerIcon
                        id={item.name}
                        drag={drag}
                        handlePopoverClick={
                          otherSignerEmail === item.signerEmail
                            ? item?.itemSign?.id === "sign" ||
                              item?.itemSign?.id === "initial"
                              ? () => onBTNclick(item.name)
                              : emptyFunction
                            : emptyFunction
                        }
                        onChangeDatePickerHandller={onChangeDatePickerHandler}
                        signerName={item?.signerName}
                        src={item?.itemSign?.src}
                        key={index}
                        item={item}
                        filledText={item.filledText ? item.filledText : false}
                        onChangeCheckBoxHandller={onChangeCheckBoxHandler}
                        onChangeTextHandller={onChangeTextHandler}
                        otherSignerEmail={otherSignerEmail}
                      />
                    </>
                  ) : (
                    <>
                      {item.signerType !== "yourself" ? (
                        <div>
                          <IconButton
                            id={item.name}
                            aria-label="add"
                            style={{
                              border: "1px solid #1F1F1F",
                              "border-radius": "0px",
                              width: "auto",
                              zIndex: "999",
                              cursor: "grab",
                              padding: "1px",
                              justifyContent: "start",
                              height: "20px",
                              fontSize: "20px",
                              color: "black !important",
                            }}
                            className="someeee"
                            onClick={(e) => {
                              handlePopoverClick(e, item);
                            }}
                            variant="contained"
                            draggable="true"
                            onDragStart={(ev) => drag(ev, item)}
                            aria-describedby="simple-popover"
                          >
                            <img
                              src={item?.itemSign?.src}
                              className="h-[15px]"
                              alt="React Logo"
                            />{" "}
                            <FormLabel
                              style={{
                                "padding-left": "0px",
                                fontSize: "20px",
                                color: "black !important",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item?.signerName}
                            </FormLabel>
                          </IconButton>
                          <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handlePopoverClose}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "center",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "center",
                            }}
                          >
                            <List>
                              <ListItem>
                                <ListItemText primary="WHO FILLES THIS OUT?" />
                              </ListItem>
                              {inputFields?.map((itemEmail, index) => {
                                return (
                                  <ListItem
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      onChangeSignerHandler(
                                        itemEmail?.email,
                                        itemEmail?.name,
                                        selectedAction,
                                        item.name
                                      )
                                    }
                                  >
                                    <ListItemText primary={itemEmail?.name} />
                                  </ListItem>
                                );
                              })}
                              <ListItem
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  onChangeSignerHandler(
                                    "",
                                    "",
                                    "yourself",
                                    item.name
                                  )
                                }
                              >
                                <ListItemText primary={"Me"} />
                              </ListItem>
                            </List>
                          </Popover>
                          {/* <PopoverComponent id={item.name} open={true} /> */}
                        </div>
                      ) : item?.filledText ? (
                        <>
                          <IconButton
                            id={item.name}
                            aria-label="add"
                            style={{
                              border: "1px solid #295c97",
                              "border-radius": "3px",
                              width: "auto",
                              minHeight: "20px",
                              zIndex: "999",

                              color: "black !important",
                              cursor: "grab",
                              padding: "0px",
                              backgroundColor: "transparent",
                              overflowWrap: "break-all",
                              wordWrap: "break-all",
                              justifyContent: "start",
                              paddingLeft: "0px",
                              "justify-content": "start !important",
                              whiteSpace: "nowrap",
                              height: "20px",
                              fontSize: "20px",
                            }}
                            className="someeee"
                            draggable="true"
                            onClick={
                              item?.itemSign?.id === "sign" ||
                              item?.itemSign?.id === "initial"
                                ? () => onBTNclick(item.name)
                                : emptyFunction
                            }
                            onDragStart={(ev) => drag(ev, item)}
                          >
                            <FormLabel
                              style={{
                                "padding-left": "0px",
                                fontFamily: `${item.fontFamily}`,
              color: "black !important",
                                "font-size": "20px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item?.filledText}
                            </FormLabel>
                          </IconButton>
                        </>
                      ) : item?.signatureDataUrl ? (
                        <IconButton
                          id={item.name}
                          aria-label="add"
                          style={{
                            border: "2px solid #295c97",
                            "border-radius": "3px",
                            width: "auto",
                            zIndex: "999",
                            cursor: "grab",
                            "justify-content": "start !important",
                            whiteSpace: "nowrap",
                            height: "20px",
                            fontSize: "20px",
                          }}
                          className="someeee"
                          draggable="true"
                          onClick={
                            item?.itemSign?.sign
                              ? () => onBTNclick(item.name)
                              : emptyFunction
                          }
                          onDragStart={(ev) => drag(ev, item)}
                        >
                          <img
                            src={item?.signatureDataUrl}
                            alt="React Logo"
                            className="signatureDrawStyle"
                          />
                        </IconButton>
                      ) : item?.itemSign?.id === "date" ? ( //This is show for date
                        <IconButton
                          id={item.name}
                          aria-label="add"
                          style={{
                            border: "1px solid #295c97",
                            "border-radius": "0px",
                            width: "auto",
                            zIndex: "999",
                            cursor: "grab",
                            padding: "0px",
                            "justify-content": "start !important",
                            whiteSpace: "nowrap",
                            height: "20px",
                            fontSize: "20px",
                          }}
                          draggable="true"
                          onDragStart={(ev) => drag(ev, item)}
                          className="someeee"
                        >
                          <img
                            src={item?.itemSign?.src}
                            className="h-[15px]"
                            alt="React Logo"
                          />
                          <DatePicker
                            selected={new Date(item.date)}
                            onChange={(date) =>
                              onChangeDatePickerHandler(date, item.name)
                            }
                            className="datePickerStyle"
                          />
                        </IconButton>
                      ) : item?.itemSign?.id === "text" ? (
                        <IconButton
                          disableFocusRipple
                          disableRipple
                          disableTouchRipple
                          id={item?.name}
                          aria-label="add"
                          draggable="true"
                          onDragStart={(ev) => drag(ev, item)}
                          style={{
                            border: "1px solid #295c97",
                            borderRadius: 0,
                            display: "inline-flex",
                            alignItems: "flex-start",
                            height: "auto",
                            cursor: "grab",
                            padding: "0px",
                            backgroundColor: "transparent",
                            zIndex: 999,
                            "justify-content": "start !important",

                            fontSize: "20px",
                          }}
                        >
                          <CustomTextField
                            defaultValue={item?.text}
                            inputValue={item?.text}
                            name={item?.name}
                            handleInputChange={onChangeTextHandler}
                            placeholder="Enter.."
                          />
                        </IconButton>
                      ) : item?.itemSign?.id === "checkbox" ? (
                        <IconButton
                          id={item.name}
                          aria-label="add"
                          style={{
                            "border-radius": "0px",
                            border: "1px solid #295c97",
                            backgroundColor: "transparent",
                            zIndex: "999",
                            cursor: "grab",
                            padding: "0px",
                            "justify-content": "start !important",

                            height: "20px",
                            fontSize: "20px",
                          }}
                          draggable="true"
                          onDragStart={(ev) => drag(ev, item)}
                        >
                          <Checkbox
                            checked={item.checked}
                            name={item.name}
                            onChange={onChangeCheckBoxHandler}
                            color="primary"
                            className="defautlCheckBoxStyle"
                            style={{
                              padding: "0px",
                            }}
                          />
                        </IconButton>
                      ) : (
                        <IconButton
                          id={item.name}
                          aria-label="add"
                          style={{
                            // border: "1px solid #eee",
                            "border-radius": "0px",
                            width: "auto",
                            zIndex: "999",
                            cursor: "grab",
                            padding: "0px",
                            justifyContent: "start",
                            border: "1px solid #1F1F1F",
                            textAlign: "start",
                            height: "20px",
                            fontSize: "20px",
                            whiteSpace: "nowrap",
                          }}
                          draggable="true"
                          onClick={
                            item?.itemSign?.id === "sign" ||
                            item?.itemSign?.id === "initial"
                              ? () => onBTNclick(item.name)
                              : emptyFunction
                          }
                          className="someeee"
                          onDragStart={(ev) => drag(ev, item)}
                        >
                          <img
                            src={item?.itemSign?.src}
                            className="h-[15px]"
                            alt="React Logo"
                          />{" "}
                          <FormLabel
                            style={{
                              "padding-left": "0px",
                              whiteSpace: "nowrap",
                              color: "black !important",
                            }}
                          >
                            {item?.itemSign?.textName}
                          </FormLabel>
                        </IconButton>
                      )}
                    </>
                  )}
                </div>
              );
            } else {
              return null;
            }
          })}
          </div>
        </Box>
      </div>
    </div>
  );
};

export default Placeholders;
